import { notification } from "ant-design-vue";
import "../utils/aws-sdk-v2";
import {AxiosClient} from '../utils/axios'
import { Glacier } from "aws-sdk";
export default ({ store, app }) => {
  const token = store.state.Chat.token;
  let retry = 0;
  const MAX_RETRY= 3;

  notification.config({ top: 60, duration: 4 });
  console.log("first")
  const connect = () =>{
    if(process.client && token){
     const socket = new WebSocket(
       `${
         process.env.BASE_URL_WEBSOCKET || app.$config.BASE_URL_WEBSOCKET
       }/ws?token=${token}`
     );
 
   
 
     socket.addEventListener("open", () => {
       console.log("Global webSocket  connection established", socket);
     });
 
 
     socket.onmessage = async function (event) {
       const list_room = JSON.parse(JSON.stringify(store.state.Chat.list_room));
       if (event?.data) {
         const data = JSON.parse(event.data);
         console.log("get message from notify", data);
      
         const room_existed = findRoomExisted(data);
         if (room_existed) {
           let new_list_room = [];
           const room_selected_id = store.state.Chat.chatRoomSelected.room_id;
 
           if (data.room_id == room_selected_id && data.type == "text") {
             new_list_room = list_room.map((item) => {
               if (item.id == data.room_id) {
                 item.new_message = {
                   ...item.new_message,
                   content: data.content,
                   created_at: data.created_at,
                 };
               }
               return item;
             });
           } else {
             new_list_room = list_room.map((item) => {
               if (item.id == data.room_id) {
                 item.new_message = {
                   ...item.new_message,
                   content: data.content,
                   created_at: data.created_at,
                 };
                 item.unseen_message += 1;
               }
               return item;
             });
           }
 
           if (new_list_room.length > 0) {
             new_list_room = new_list_room.sort((a, b) => {
               return (
                 b?.new_message?.created_at ||
                 0 - a?.new_message?.created_at ||
                 0
               );
             });
           }
 
           store.commit("Chat/SET_LIST_ROOM", new_list_room);
         } else {
           console.log("init chat");
           //call api get list_room
           await store.dispatch("Chat/getListRoom");
         }
         
         if (
           app.context.route.query.p != "chat" &&
           app.context.route.name != "livestream"
         ) {
          console.log('notification')
           notification.info({
             message: "Bạn có tin nhắn mới",
             onClick: () => {
               // check case if not have room -> await dispatch getListRoom -> call findRoomExisted to get room
               const room_selected = findRoomExisted(data);
 
               if (room_selected) {
                 store.commit("Chat/SET_CHAT_ROOM_SELECTED", {
                   room_id: room_selected?.id,
                   name: room_selected?.name,
                   avatar: `${this.mediaUrl}${this.logo}`,
                   current_pro_id: room_selected?.current_pro_id,
                 });
               }
               app.router.push("/user?p=chat");
               notification.destroy();
             },
           });
         }
 
         // Livestream
         if (app.context.route.name === "livestream") {
           let list_livestream = JSON.parse(
             JSON.stringify(store.state.LiveStream.livestreamConnectionList)
           );
 
           if (Array.isArray(list_livestream)) {
              console.log({list_livestream})
              console.log({dataId:data.id})

              // check room already exist 
             const index = list_livestream.findIndex(
               (item) => item.room_id == data.room_id
             );
             console.log({index})
             if (index === -1) {
               let messages = [];
               messages = await getMessageInRoom(token,data.room_id,data.pro_id)
               console.log({messages})
               let profile = null;
             
               if(messages && messages[0] && messages[0]?.profile?.name){
                console.log({firstMsg:messages[0]})
                console.log("have message profile name")
                profile = {name:messages[0]?.profile?.name}
               }
               if(messages.length>0){
                messages = messages.map(item => {
                  return{
                    content: item.content,
                    created_at: item.created_at,
                  }
                })
              }
              messages.push( {
                content: data.content,
                created_at: data.created_at,
              })
 
               list_livestream.push({
                 ...data,
                 profile,
                 unseen_message_counter: 1,
                 ws_url: `${app.context.$config.BASE_URL_WEBSOCKET}/rooms/${data.room_id}/ws?token=${token}&current_pro_id=${store.state.Chat.profile.pk}`,
                 messages
               });
               console.log({list_livestream})
             } else {
               let item_at_index = list_livestream[index];
               console.log({item_at_index})
               item_at_index.unseen_message_counter++;
               console.log({messageItem:item_at_index.messages})
               let messages =item_at_index.messages
               messages.unshift({
                     content: data.content,
                 created_at: data.created_at,
                 pro_id:data.pro_id
               })
               console.log({messages})
               item_at_index.messages = messages;
               console.log({item_at_index})
               list_livestream[index] = item_at_index;
             }
             store.commit(
               "LiveStream/SET_LIVESTREAM_CONNECTION_LIST",
               list_livestream
             );
           }
         }
       }
     };
 
     socket.addEventListener("error", (error) => {
       if(retry<3){
         console.error('Socket is error. Reconnect will be attempted in 0.5 second.', error);
       setTimeout(function() {
         connect();
         retry++;
       }, 0.5);
       }else{
         console.error('Socket is error. Cannot reconnect because was retried 3 time.');
       }
     });
 
     socket.addEventListener("close", () => {
       console.log("WebSocket connection closed");
     });
    }
   }

   connect();
  

  const getMessageInRoom = async(token,room_id,current_pro_id) =>{
    try {
      const response = await AxiosClient.get(`/eduzone/api/chat/get_room`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          id: room_id,
          current_pro_id: current_pro_id,
        },
      });
      if (response.data?.data?.code && response.data?.data?.data) {
        console.log({getMessageInRoom:response.data.data.data})
        return response.data?.data?.data;
        
        
       
      }
    } catch (error) {
      console.log({ error });
    }
  }

  const findRoomExisted = (data) => {
    const list_room = JSON.parse(JSON.stringify(store.state.Chat.list_room));
    const list_room_existed = list_room.find((item) => item.id == data.room_id);
    //  console.log({data});
    // console.log({list_room});

    // console.log({list_room_existed})

    return list_room_existed;
  };
};
